import { NgModule } from '@angular/core';
import { IsNullPipe } from "./isnull.pipe";
import { MaskPipe } from "./mask.pipe";
import { PrefixPipe } from "./prefix.pipe";
import { SimNaoPipe } from './sim-nao.pipe'
import { SuffixPipe } from "./suffix.pipe";;

@NgModule({
  declarations: [
    IsNullPipe,
    MaskPipe,
    PrefixPipe,
    SimNaoPipe,
    SuffixPipe
  ],
  exports: [
      IsNullPipe,
      MaskPipe,
      PrefixPipe,
      SimNaoPipe,
      SuffixPipe
  ]
})
export class PipesModule { }
